import { UserRegisterResponse } from "../../proto/UserRegister_pb";
import BaseHandler from "../BaseHandler";

export default class HandleUserRegisterResponse extends BaseHandler<UserRegisterResponse> {
  handle() {
    const userRegisterResponse = this.response.toObject();
    //
  }
}
